import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CommunicationService} from '../../../services/communication.service';
import {PermissionsService} from '../../../services/permissions.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MagicInsightsService} from '../../../services/magic-insights';
import {NotificationService} from '../../../services/notification.service';
import { Router } from '@angular/router';

@Component({
  selector: 'manage-module',
  standalone: false,
  templateUrl: './manage-module.component.html',
  styleUrl: './manage-module.component.css'
})
export class ManageModuleComponent implements OnInit {

  readonly MODEL_KEY = 'organisation_aira_module';
  readonly NOTIFICATION_TYPE = 'magic_insights_progress';

  dropDownSelectedModuleId: any;
  isSuperuser = false;
  moduleId: any;
  availableModules: any = null;
  moduleDetails: any;
  organisationUsers = [];
  organisationTeams = [];

  // Notification variables
  notifications: any[] = [];
  loadingNotifications = false;

  constructor(
    private route: ActivatedRoute,
    private communicationService: CommunicationService,
    private permissionsService: PermissionsService,
    private snackbar: MatSnackBar,
    private magicInsightsService: MagicInsightsService,
    private notificationService: NotificationService,
    private router: Router
  ) {}

  ngOnInit() {
    this.moduleId = this.route.snapshot.queryParamMap.get('id');

    this.magicInsightsService.getMagicInsightsAvailableModules().subscribe(allMods => {
        this.availableModules = allMods;
        if (!this.moduleId){
            if (this.availableModules?.length){
              this.moduleId = this.availableModules[0].id;
            }
        }
        if (this.moduleId){
            this.dropDownSelectedModuleId = this.moduleId;

            // Restored original logic
            this.magicInsightsService.getMagicInsightsModuleInfo(this.moduleId).subscribe(indMod => {
                this.moduleDetails = indMod;
                this.communicationService.getIsSuperUserMessage().subscribe(isSuperuser => {
                this.isSuperuser = isSuperuser;
                  if (this.isSuperuser && this.moduleDetails?.perms_access) {
                      this.permissionsService
                        .getSuperuserTeamsAndUsers()
                        .subscribe(data => {
                          this.organisationTeams = data.organisation_teams;
                          this.organisationUsers = data.organisation_users;
                        });
                  }
                })
            });
        }
    });

    this.loadAndClearNotifications();
  }

  onModuleChange() {
    if (this.dropDownSelectedModuleId !== this.moduleId){
      this.moduleId = this.dropDownSelectedModuleId;
      this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { id: this.moduleId },
          queryParamsHandling: 'merge', // Keep other existing params
        });
      this.magicInsightsService.getMagicInsightsModuleInfo(this.moduleId).subscribe(indMod => {
          this.moduleDetails = indMod;
      });
    }
  }

  loadAndClearNotifications() {
    this.loadingNotifications = true;

    // 1. Fetch the notifications to display them
    this.notificationService.getNotifications(this.NOTIFICATION_TYPE).subscribe(
      (data) => {
        this.notifications = data;
        this.loadingNotifications = false;

        // 2. Once fetched, mark them as read so the badge clears
        this.markNotificationsRead();
      },
      (error) => {
        console.error('Error fetching notifications', error);
        this.loadingNotifications = false;
      }
    );
  }

  markNotificationsRead() {
    this.notificationService.markAllNotificationsAsRead(this.NOTIFICATION_TYPE).subscribe(() => {
        // 3. Manually update localStorage so the Navbar badge clears immediately
        localStorage.setItem('MagicInsightsAlertCount', '0');
        localStorage.setItem('lastMagicInsightsAlertCountCheck', new Date().getTime().toString());
    });
  }

  onPermissionChanged(event: any) {
    this.snackbar.open('Permissions updated')
  }

}
